import React from "react";

const CancellationList = (props) => {
    const { handleStatusChange, data, planId } = props;
    
    return (
        <div className="small_container">
            <h3 className="font-weight-bolder text-dark network_title_wt mb-0">Please let us know the reason you want to cancel your Tagbox Subscription.</h3>
            <div className="cancellation-list mt-5">
                <div className="cancellation-item">
                    {
                        data.map((item, index) => {   
                            return !((planId == 53 || planId == 58) && item.interHeading == 'Too expensive') ? <div className="card d-flex py-5 px-8 mb-5 cursor-pointer" key={index} onClick={() => handleStatusChange(item, item.type)}>
                            <div className="card-inner d-flex flex-wrap align-items-center">
                                <div className="card-icon"> {item.icon} </div>
                                <div className="card-details">
                                    <h5 className="font-weight-bolder text-dark network_title_wt mb-2" >{item.interHeading}</h5>
                                    <p className="mb-0">{item.text}</p>
                                </div>
                            </div>
                        </div> : null
                        })
                    }
                </div>
            </div>
        </div>
    )
}


export default CancellationList;